module.exports = __webpack_public_path__ + "static/media/joining_bonus_mob.0c63cc79.webp";